import { Box, styled } from '@mui/material'
import Divider from '@mui/material/Divider'
import { Button } from '../../../../../../components'
import { EditIconContainer } from '../../../../components/StoredDeliveriesListDetails/StoredDeliveriesListDetails.styled'

const Header = styled(Box)`
  width: 100%;
  position: relative;
`

const SliderContainer = styled(Box)`
  width: 100%;
  overflow: auto;
  position: relative;
`

const Slider = styled(Box)`
  width: 100%;
`

const SliderGroupLines = styled(Box)`
  width: 100%;
  height: 60px;
  position: relative;
`

const List = styled(Box)`
  width: 100%;
  display: flex;
  gap: 10px;
  padding-bottom: 15px;
  white-space: nowrap;
`

const VerticalLine = styled(Divider)(({ theme }) => ({
  position: 'absolute',
  borderStyle: 'dashed',
  borderColor: theme.palette.customGrey.three,
  width: '1px',
  height: '45px',
  top: '-45px',
  left: '45px',
}))

const ButtonWrapper = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
`

const GroupButton = styled(Button)`
  width: 200px;
  height: 44px;
`

const StyledDivider = styled(Divider)`
  position: absolute;
  top: 13px;
  border-style: dashed;
`

const StyledEditIconContainer = styled(EditIconContainer)`
  position: absolute;
  top: 13px;
  cursor: pointer;
`

export {
  SliderContainer,
  Slider,
  SliderGroupLines,
  Header,
  List,
  VerticalLine,
  ButtonWrapper,
  GroupButton,
  StyledDivider,
  StyledEditIconContainer,
}
